import { queryParamsBuilder } from '../queryParamsBuilder'

type BuildProductDetailsURLParams = {
  region: string
  categorySlug: string
  slug: string
  productId: string
  size?: string
  groupCardProject?: string
}

export const buildProductDetailsURL = ({
  region,
  categorySlug,
  slug,
  productId,
  size,
  groupCardProject,
}: BuildProductDetailsURLParams) => {
  const queryParams = queryParamsBuilder()
    .add('size', size)
    .add('groupCardProject', groupCardProject)
    .build()

  return `/${region}/${categorySlug}/p/${slug}/${productId.toLowerCase()}/${queryParams}`
}
